
<template>
    <div>
        <!-----------------  responsive menu -------------------->
        <v-navigation-drawer absolute v-model="sideNav" width="340" class="hidden-sm-and-up mobile-menu elevation-bg-color">
            <v-list>
                <v-list-tile to="/home" v-if="!getUserData.embedded && getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                    <v-list-tile-content class="color-headings-text">
                        {{text('api.button.home')}}
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/assessment-list" v-if="getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC' && !getUserData.embedded">
                    <v-list-tile-content class="color-headings-text">
                        {{text('api.summary.list.assessments')}}
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-for="code in docCodeList"
                             :key="code"
                             :to="{name: 'DocPage', query: {type: code}}"
                             v-if="!getUserData.embedded">
                    <v-list-tile-content class="color-headings-text">
                        {{text("api.doc.pro." + code)}}
                    </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>



                <SettingsList
                    :side-nav="sideNav"
                    v-on:closeSideNav="closeSideNav" :get-role="getRole" :app-type="appType"></SettingsList>

                <v-list  v-if="getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC' && !getUserData.certificate"
                         class="account-settings no-padding-top">
                    <v-list-tile >
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <router-link :to="'/user-account'" class="user-account underline-none">
                                    <my-account-icon :height="20" :width="20" class="user account"/>
                                    {{text("api.button.myaccount")}}
                                </router-link>
                            </v-list-tile-title>
                            <v-list-tile-sub-title></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

                <v-divider></v-divider>

                <v-list  v-if="getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC' && !getUserData.embedded" class="account-settings">
                    <v-list-tile to="/" @click="logOut" >
                        <v-list-tile-content class="logout-mobile color-headings-text">
                            <logout-icon :height="20" :width="20" class="user logout"/>
                            {{text('api.button.logout')}}
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-list>
        </v-navigation-drawer>

        <!----------------- general menu ---------------------->
        <v-toolbar fixed class="header header-menu ">
            <v-toolbar-side-icon
                v-if="!sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
            </v-toolbar-side-icon>

            <v-toolbar-side-icon
                v-if="sideNav"
                @click.native.stop="sideNav = !sideNav"
                class="hidden-sm-and-up mobile-menu-btn">
                <close-icon :svg-fill-class="'svg-secondary-color'"/>
            </v-toolbar-side-icon>

            <v-toolbar-title v-if="logo">
                <img v-bind:src="logo" alt="smass logo"  class="logo">
            </v-toolbar-title>

            <v-toolbar-items class="pages hidden-xs-only" v-if="!getUserData.embedded">
                <v-btn v-if="getRole" flat to="/home" :ripple="false">
                        {{text('api.button.home')}}
                </v-btn>

                <v-btn flat to="/assessment-list" :ripple="false"  v-if="getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC'">
                        {{text('api.summary.list.assessments')}}
                </v-btn>

            </v-toolbar-items>

            <v-spacer></v-spacer>

            <v-toolbar-items class="hidden-xs-only language-dropdown-container no-margin-right">

                <doc-dropdown :doc-code-list="docCodeList">
                    <router-link
                        :slot="['dropdown-btn', code].join('-')"
                        :to="{name: 'DocPage', query: {type: code}}"
                        :key="code"
                        v-for="code in docCodeList"
                        :class="{
                            'doc-dropdown-btn': docCodeList.length !== 1,
                            'doc-btn': docCodeList.length === 1,
                            }"
                    >
                        {{text("api.doc.pro." + code)}}
                    </router-link>
                </doc-dropdown>

                <SettingsMenu :get-role="getRole" :app-type="appType"/>

                <v-menu
                    v-model="account"
                    :nudge-width="200"
                    class="btn-account menu-settings"
                    absolute
                    bottom
                    nudge-top="-20"
                    offset-x
                    :close-on-content-click="false"
                    v-if="getRole && appType !=='PF_CHATBOT_STUDY' && appType !=='PF_CHATBOT' && appType !== 'PF_CHATBOT_PUBLIC' && !getUserData.embedded"
                >
                    <svg-button
                        slot="activator">
                        <template>
                            <account-icon class="settings"/>
                        </template>
                    </svg-button>
                    <v-card >
                        <v-list class="user-logged">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <user-active-icon/>
                                        {{ getFullName }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-divider></v-divider>
                        <v-list class="account-settings">
                            <v-list-tile  v-if="!getUserData.certificate">
                                <v-list-tile-content>
                                    <v-list-tile-title class="flex-align-center">
                                        <router-link :to="'/user-account'" class="user-account padding-left-xs underline-none flex-align-center">
                                            <my-account-icon :height="20" :width="20"  class="user account"/>
                                            {{text("api.button.myaccount")}}
                                        </router-link>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                            <v-list-tile class="padding-left-xs">
                                <v-btn flat v-on:click="logOut" :ripple="false" class="btn-logout">
                                    <logout-icon :height="20" :width="20" class="user logout"/>
                                    {{text('api.button.logout')}}
                                </v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-menu>

            </v-toolbar-items>
        </v-toolbar>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import LoginPage from '../../../common/components/login/LoginPage';
import Vue from "vue";
import DocDropdown from "../../../common/components/shared/DocDropdown";
import SettingsIcon from "../../../common/components/svg/shared/settingsIcon";
import AccountIcon from "../../../common/components/svg/shared/accountIcon";
import MyAccountIcon from "../../../common/components/svg/shared/myAccountIcon";
import LogoutIcon from "../../../common/components/svg/shared/logoutIcon";
import SvgButton from "../../../common/components/shared/SvgButton";
import BaseSwitch from "../../../common/components/shared/BaseSwitch";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import LightThemeIcon from "../../../common/components/svg/shared/lightThemeIcon";
import DarkThemeIcon from "../../../common/components/svg/shared/darkThemeIcon";
import HighContrastLightIcon from "../../../common/components/svg/shared/highContrastLightIcon";
import HighContrastDarkIcon from "../../../common/components/svg/shared/highContrastDarkIcon";
import SettingsMenu from "../../../common/components/shared/SettingsMenu";
import SettingsList from "../../../common/components/shared/SettingsList";
import UserActiveIcon from "../../../common/components/svg/shared/userActiveIcon.vue";

export default {
        name: 'HeaderBar',
        components: {
            UserActiveIcon,
            SettingsList,
            SettingsMenu,
            HighContrastDarkIcon,
            HighContrastLightIcon,
            DarkThemeIcon,
            LightThemeIcon,
            CloseIcon,
            BaseSwitch,
            SvgButton,
            LogoutIcon,
            MyAccountIcon,
            AccountIcon,
            SettingsIcon,
            DocDropdown,
            LoginPage
        },
        data () {
            return {
                sideNav: false,
                account: false,
                currentItem: 'home',
                settings: false,
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                arrowDownPlugin: Vue.ArrowDown.arrowDownSvg,
                menuIconPlugin: Vue.MenuIcon.menuIconSvg

            }
        },

        beforeMount() {

            let mustShowPriorityList = sessionStorage.getItem('must-show-priority-list');

            if(this.getPriorityListVal || mustShowPriorityList) {
                if (mustShowPriorityList !== null) {
                    this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                        if (mustShowPriorityList) {
                            this.$router.push('/symptoms-list');
                        } else {
                            this.$router.push('/symptoms-questions');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                        if (mustShowPriorityList) {
                            this.$router.push('/assessment-start-list');
                        } else {
                            this.$router.push('/assessment-start');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);

                    } else {
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', mustShowPriorityList);
                        this.settings = false;

                    }
                }
            }

            let mustShowEvaluationScreen = sessionStorage.getItem('must-show-evaluation-screen');
            if(this.getEvaluationScreenVal || mustShowEvaluationScreen) {
                if (mustShowEvaluationScreen !== null) {
                    this.$store.commit('TranslationStore/setMustShowEvaluationPage', mustShowEvaluationScreen);
                }
            }
        },

        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                getSelectedLang: 'TranslationStore/getSelectedLang',
                isAdmin: 'UserStore/getIsAdmin',
                getFullName: 'UserStore/getFullName',
                getRole: 'UserStore/getRole',
                logo: 'TranslationStore/getLogo',
                appType: 'TranslationStore/getAppTypeName',
                getUserData: 'UserStore/getUserData',
                getMustShowEvaluationPage: 'TranslationStore/getMustShowEvaluationPage',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getPriorityListVal: 'TranslationStore/getPriorityListVal',
                getEvaluationScreenVal: 'TranslationStore/getEvaluationScreenVal',
                getDocCodeList: 'TranslationStore/getDocCodeList',
                getDocApplicationType: 'TranslationStore/getDocApplicationType',
            }),

            languageListForDropdown() {

                let langsForDropdown = [];
                this.languageList.forEach((langKey) => {
                    langsForDropdown.push({
                        key: langKey,
                        name: this.text("api.language.name." + langKey)
                    });
                });
                return langsForDropdown;
            },


            selectedLang: {
                get() {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set(newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            },

            selectedTheme: {
                get() {
                    return this.$store.state["TranslationStore"].theme;
                },

                set(newVal) {
                    this.$store.commit('TranslationStore/setTheme', newVal)
                }
            },


            mustShowAssessmentList: {

                get() {

                    return this.$store.getters['SymptomsQuestionsStore/getMustShowAssessmentList'];

                },

                set(newVal) {
                    if (newVal) {
                        this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", true).then((response) => {

                        });
                    } else {
                        this.$store.dispatch("SymptomsQuestionsStore/submitAssessmentType", false).then((response) => {

                        });
                    }
                    if (this.$router.currentRoute.path === '/symptoms-list' || this.$router.currentRoute.path === '/symptoms-questions') {

                        if (newVal) {
                            this.$router.push('/symptoms-list');
                        } else {
                            this.$router.push('/symptoms-questions');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);

                    } else if (this.$router.currentRoute.path === '/assessment-start' || this.$router.currentRoute.path === '/assessment-start-list') {

                        if (newVal) {
                            this.$router.push('/assessment-start-list');
                        } else {
                            this.$router.push('/assessment-start');
                        }
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);

                    } else {
                        this.$store.commit('SymptomsQuestionsStore/setMustShowAssessmentList', newVal);
                        this.settings = false;

                    }
                }

            },

            mustShowEvaluationPage: {
                get() {

                    return this.$store.getters['TranslationStore/getMustShowEvaluationPage'];

                },

                set(newVal) {
                    if (newVal) {
                        this.$store.dispatch("TranslationStore/submitEvaluationPageType", true).then((response) => {

                        });
                    } else {
                        this.$store.dispatch("TranslationStore/submitEvaluationPageType", false).then((response) => {

                        });
                    }
                }

            },

            docCodeList() {
                const applicationType = this.getDocApplicationType();
                return this.getDocCodeList(applicationType);
            }

    },

        mounted() {
            let selectedInputIcon = document.getElementsByClassName('language-option');
            if (selectedInputIcon.length !== 0) {
                let selectLanguage = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
                selectLanguage[0].innerHTML = this.arrowDownPlugin();
            }

            let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
            if (menuIcon) {
                menuIcon.innerHTML = this.menuIconPlugin();
            }
        },

        watch: {
            // Watch on sideNav to set the radio icon to a Svg.
            sideNav(newVal, oldVal) {
                // If we close the side menu we should replace the menu icon with the svg
                if (!newVal) {
                    this.$nextTick(() => {
                        let menuIcon = document.querySelector('.toolbar__side-icon.btn.btn--icon i.icon');
                        if (menuIcon) {
                            menuIcon.innerHTML = this.menuIconPlugin();
                        }
                    })

                }
            },
        },

        methods: {
            logOut() {
                this.$store.dispatch("UserStore/submitLogout").then((response) => {
                    this.$router.push('/');
                });
            },

            closeSideNav() {
                if(this.sideNav) {
                    this.sideNav = false;
                }
            },

            goToHomePage() {
                this.$router.push('/home');
            },

            setCookie(name, value, days) {
                let expires = "";
                if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            },

            goToAssessmentListPage() {
                this.$router.push('/assessment-list');
            },
            goToTestsPage() {
                this.$store.commit('TestStore/setGetTreeData', false);
                this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
                    this.$router.push('/tests');
                });
            }

        },

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .btn-menu.svg-button .btn__content {
        background-color: $color-brand-primary !important;
    }


    .toolbar.toolbar--fixed.header {
        background-color: $color-elevation-background;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 1px solid $color-block-border;

        .toolbar__content {

            .user {
                width: 18px;
                height: 18px;
                margin-right: 2px;
            }
        }

    }

    .btn-menu {
        max-width: 100%;

        .settings, .user {
            height: 40px;
            width: 40px;

            &:first-of-type {
                // margin-left: 5px !important;

                span {
                    position: relative;
                    top: 2px;
                }
            }
        }
    }



    .menu__content {

        .list__tile__action {
            min-width: 100%;

            .input-group.input-group--selection-controls {
                min-width: 100%;
            }
        }
    }

    .settings {
        font-weight: $font-size-medium;

    }

    .btn-logout-icon:hover {
        cursor: pointer;
    }

    .user-account {
        color: $color-headings-text;
    }


    .user-logged img, .account-settings img {
        width: 22px;
    }

    .account-settings .account{
        position: relative;
        margin-right: 15px;
    }

    .account-settings .logout {
        margin-right: 16px;
    }

    .user-logged .list__tile__title:first-of-type {
        height:  44px !important;

        svg {
            position: relative;
            top: 10px;
            width: 32px;
            margin-right: 7px;
        }
    }

    hr {
        border-top: 1px solid $color-element-outline;
    }
    // TODO Move this to global and use without !important
    .menu-settings {
        display: flex !important;
        align-items: center !important;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/shared/HeaderBar.vue